import { ContractAcceptanceMethod, type SignContractPayload } from './types';

// Pure signing logic for the merchant self-onboarding contract flow (PE-2097),
// split out from SignContractPage so the submit-gating and payload shape are unit-testable.

export interface SigningState {
  /** Whether the contract preview has loaded. */
  hasContract: boolean;
  method: ContractAcceptanceMethod;
  /** EXPLICIT_ACCEPT: the "I agree" checkbox. */
  accepted: boolean;
  /** E_SIGNATURE: a signature has been drawn. */
  hasSignature: boolean;
  /** A sign request is already in flight. */
  submitting: boolean;
}

/**
 * The submit button is enabled only when the contract is loaded, no request is in
 * flight, and the chosen method's requirement is met (checkbox for EXPLICIT_ACCEPT,
 * a drawn signature for E_SIGNATURE).
 */
export const canSubmitSigning = (s: SigningState): boolean => {
  if (!s.hasContract || s.submitting) return false;
  return s.method === ContractAcceptanceMethod.EXPLICIT_ACCEPT ? s.accepted : s.hasSignature;
};

/**
 * Build the watchman `SignContractDto` body. `signatureData` is included ONLY for
 * E_SIGNATURE (and only when present) — EXPLICIT_ACCEPT must never carry one.
 */
export const buildSignPayload = (
  token: string,
  method: ContractAcceptanceMethod,
  signature: string | null,
): SignContractPayload => ({
  token,
  acceptanceMethod: method,
  ...(method === ContractAcceptanceMethod.E_SIGNATURE && signature ? { signatureData: signature } : {}),
});
